var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDownPlain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "10px",
    viewBox: "0 0 18 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "8CF0FF96-9096-48D6-8BB7-117DB118EE0C@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop---Landing-Page",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Promo-Landing",
    transform: "translate(-908.000000, -709.000000)",
    fill: "#005587"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(0.000000, 312.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(755.000000, 377.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.640214,25.8910926 L159.097123,33.6305663 C158.617292,34.1231446 157.839327,34.1231446 157.359728,33.6305663 C156.880091,33.1384263 156.880091,32.3402225 157.359728,31.8481223 L164.034199,24.9998705 L157.359922,18.1518578 C156.880285,17.6595186 156.880285,16.8613945 157.359922,16.3692544 C157.83956,15.8769152 158.617486,15.8769152 159.097317,16.3692544 L166.640408,24.1088477 C166.880227,24.3550372 167,24.6773543 167,24.9998307 C167,25.3224665 166.879994,25.6450225 166.640214,25.8910926 Z",
    id: "Path",
    transform: "translate(162.000000, 25.000000) rotate(90.000000) translate(-162.000000, -25.000000) "
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownPlain);
export default __webpack_public_path__ + "static/media/ArrowDownPlain.78c89eb469fd9609368061f96fe519b2.svg";
export { ForwardRef as ReactComponent };